var map = {
	"./Audio 1.pdf": 1422,
	"./Audio 2.pdf": 1423,
	"./Audio 3.pdf": 1424,
	"./Audio 4.pdf": 1425,
	"./Audio 5.pdf": 1426,
	"./Audio 6.pdf": 1427,
	"./Audio 7.pdf": 1428,
	"./Audio 8.pdf": 1429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1421;